import { SEO, breadcrumbSchema } from '../components/SEO';
import { STATIC_SEO } from '../data/seoConfig';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { LocationCard } from '../components/cards';
import { Stagger, StaggerItem } from '../components/Reveal';
import { LOCATIONS } from '../data/locations';
import { IMAGES } from '../data/site';

const LocationsPage = () => (
  <>
    <SEO
      title={STATIC_SEO.areas.title}
      description={STATIC_SEO.areas.description}
      path="/service-areas/"
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Service Areas', path: '/service-areas/' }])]}
    />
    <PageHero
      overline="Service Areas"
      title="Serving the Omaha metro & surrounding Nebraska communities"
      intro="Free on-site consultations across our ten-community service region. Every city page below covers the local details — homeowner needs, project approaches, and FAQs specific to your community."
      image={IMAGES.homeDusk}
      breadcrumbs={[{ name: 'Home', path: '/' }, { name: 'Service Areas' }]}
    />
    <section className="py-20 md:py-28">
      <div className="container-site">
        <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {LOCATIONS.map((l) => (
            <StaggerItem key={l.slug}><LocationCard location={l} /></StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
    <CTASection title="Your community, our backyard" text="We've been designing and building across these communities for over 22 years. Start with a free consultation at your home." testId="areas-cta" />
  </>
);

export default LocationsPage;
